import React, {createContext} from 'react'

interface ModalAcceptContextInterface {
  modalAccept: React.ReactNode | null
  setAcceptModal: (value: React.ReactNode | null) => void
  hideAcceptModal: () => void
  modalAcceptIsShow: boolean
}

const modalAcceptContext = createContext<ModalAcceptContextInterface>({
  modalAccept: null,
  setAcceptModal: (value) => {},
  hideAcceptModal: () => {},
  modalAcceptIsShow: false,
})

export default modalAcceptContext
